<template>
    <div class="addword" v-loading="saveLoading">
        <div
            class="rightmouse"
            :style="{
                top: rightMouseTop + 'px',
                left: rightMouseLeft + 'px',
                opacity: rightMouseFlag ? '1' : '0',
            }"
        >
            <p>© 图片版权保护</p>
        </div>
        <header>
            <p>创建文稿</p>
            <div class="btn" v-if="$route.query.id">
                <el-button @click="updateWord">保存</el-button>
                <el-button @click="$router.go(-1)">返回</el-button>
            </div>
        </header>

        <div class="nr">
            <div class="pic">
                <el-select
                    class="my-el-select"
                    v-model="pic.id"
                    style="width:100%;"
                    placeholder="所属资源库"
                    @change="inputchange"
                >
                    <el-option
                        v-for="item in atlaslist"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
                <el-select
                    class="my-el-select"
                    v-model="pic.user"
                    style="width:100%;"
                    placeholder="投稿人"
                    @change="inputchange"
                >
                    <el-option
                        v-for="item in contributorList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <div
                    :class="picList.length > 0 && !picLoading ? 'piclist' : 'picnone'"
                    @scroll="picScroll($event)"
                >
                    <div v-if="picList.length > 0" class="piccommon" ref="picdetail">
                        <div class="detail" v-for="(e,i) in picList" :key="i">
                            <el-image
                                style="cursor: pointer;"
                                fit="cover"
                                @contextmenu.prevent="rightShow($event)"
                                ondragstart="return false;"
                                @click="choosePic(e)"
                                :src="e.src"
                            >
                                <div slot="error" class="image-slot">
                                    <img src="@/assets/house/onloadpicerror.png" alt />
                                </div>
                            </el-image>
                        </div>
                    </div>
                    <div class="picLoading" v-if="picLoading">
                        <img width="150px" src="@/assets/blue-preloader.gif" alt />
                    </div>
                    <div class="none" v-if="picList.length <= 0 && !picLoading">
                        <img src="@/assets/piclist/nonr.png" alt />
                    </div>
                </div>
            </div>
            <div class="word" :style="{width:$route.query.id?'73%':'43%'}">
                <div class="title">
                    <p>文章标题</p>
                    <el-input v-model="word.title" class="my-el-input" placeholder="请输入文章标题"></el-input>
                </div>
                <div class="text">
                    <p>正文</p>
                    <div id="websiteEditorElem"></div>
                </div>
            </div>
            <div class="atlas" v-if="!$route.query.id">
                <div class="curtain">
                    <h4
                        @click="changeUploadMode"
                        :class="
                            uploadMode === 0 ? isSimple ? 'simpleactive' : 'active' : ''
                        "
                    >创建新资源夹</h4>
                    <h4
                        @click="changeUploadMode"
                        :class="
                            uploadMode === 1 ? isSimple ? 'simpleactive' : 'active' : ''
                        "
                    >归档到资源夹</h4>
                </div>

                <div v-if="uploadMode === 0" class="jia" v-loading='addWordLoading'>
                    <el-form :model="atlasForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                        <!-- 归属图库 -->
                        <el-form-item prop="libId">
                            <div @click.stop class="inputlist">
                                <p>归属资源库</p>
                                <el-cascader
                                    style="width: 100%;"
                                    :disabled="isSave"
                                    v-model="atlasForm.libId"
                                    :props="{value:'id',label:'name',children:'children'}"
                                    :options="options"></el-cascader>
                                <!-- <el-select
                                    style="width: 100%"
                                    v-model="atlasForm.libId"
                                    placeholder="请选择"
                                    :disabled="isSave"
                                >
                                    <el-option
                                        v-for="item in atlaslist"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        v-html="'<span style=color:#303030;>' + item.name + '</span>'"
                                    ></el-option>
                                </el-select> -->
                            </div>
                        </el-form-item>

                        <!-- 资源集名称 -->
                        <el-form-item prop="name">
                            <div @click.stop class="inputlist">
                                <p>资源夹名称</p>
                                <el-input
                                    style="width: 100%;"
                                    v-model="atlasForm.name"
                                    :disabled="isSave"
                                    placeholder="请输入名称"
                                ></el-input>
                            </div>
                        </el-form-item>

                        <!-- 相册说明 -->
                        <el-form-item prop="desc">
                            <div @click.stop class="inputlist">
                                <p>资源夹说明</p>
                                <el-input
                                    class="elinput"
                                    type="textarea"
                                    :autosize="{ minRows, maxRows }"
                                    style="width: 100%:"
                                    placeholder="请输入说明"
                                    v-model="atlasForm.desc"
                                    :disabled="isSave"
                                ></el-input>
                            </div>
                        </el-form-item>

                        <!-- 可见性 -->
                        <el-form-item prop="status">
                            <div @click.stop class="inputlist">
                                <p>可见性</p>
                                <el-radio-group
                                    :disabled="isSave || statusFlag"
                                    v-model="atlasForm.status"
                                    size="medium"
                                    :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                                >
                                    <el-radio-button label="0">私密</el-radio-button>
                                    <el-radio-button label="1">公开</el-radio-button>
                                </el-radio-group>
                            </div>
                        </el-form-item>

                        <div @click.stop class="btn">
                            <el-button
                                :disabled="isrouteBtn"
                                @click.stop="save('ruleForm')"
                                :style="{ 'border': 'none', 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
                            >
                                <i class="save"></i>
                                <span class="text">保存</span>
                            </el-button>
                        </div>
                    </el-form>
                </div>

                <div v-if="uploadMode === 1" class="jia" v-loading='addWordLoading'>
                    <el-form
                        @submit.native.prevent
                        class="demo-ruleForm"
                    >
                        <!-- 归属图库 -->
                        <el-form-item>
                            <div @click.stop class="inputlist">
                                <p>指定资源夹</p>
                                <el-input
                                    class="elinput"
                                    style="width: 100%"
                                    v-model="myselect"
                                    placeholder="请输入关键字进行筛选"
                                    @input="myLibChange"
                                    :disabled="isSave"
                                >
                                </el-input>
                            </div>
                        </el-form-item>

                        <el-table
                            :data="myAtlas"
                            stripe
                            height="400"
                            @row-click="rowClick"
                            highlight-current-row
                            style="width: 100%; overflow-y: auto"
                            v-loading="tableLoading"
                        >
                            <el-table-column prop="name" show-overflow-tooltip label="资源夹名"></el-table-column>
                            <el-table-column prop="date" label="创建时间"></el-table-column>
                        </el-table>

                        <div @click.stop class="btn">
                            <el-button
                                :disabled="isrouteBtn"
                                @click.stop="saveG('ruleForm')"
                                :style="{ 'border': 'none', 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
                            >
                                <i class="save"></i>
                                <span class="text">保存</span>
                            </el-button>
                        </div>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import { powersObj, allowLib, allowPushChannel } from "@/constants/powers";
import { picPrefix } from "@/constants/piccommon";
import { formatConversion } from "@/plugins/getdate";

//编辑器
import E from "wangeditor";

import getMD5 from "@/plugins/getMD5";

import { listUser } from "@/api/user";
import { listLib, listMyPowerLib } from "@/api/lib";
import { advSearchPicture, searchAtlas } from "@/api/search";
import {
    uploadPic,
    uploadPicChunk,
    uploadPicChunkMerge,
    getFileInfoByHash
} from "@/api/file";
import { addAtlas } from "@/api/atlas";
import { create,selectInfo,updateContent } from "@/api/word";


export default {
    computed: {
        ...mapGetters(["createUid"]),
    },
    data() {
        return {
            //保存加载
            saveLoading:false,



            updateWordInfo : null,
            addWordLoading:false,

            //鼠标右击
            rightMouseTop: 0,
            rightMouseLeft: 0,
            rightMouseFlag: false,

            //权限
            powersObj,
            allowLib,
            allowPushChannel,

            //图片前缀
            picPrefix,

            //图片筛选条件
            pic: {
                id: '',
                user: ''
            },
            atlaslist: [],
            options:[],
            contributorList: [],
            totalPic: 0,
            pagePic: 0,
            pageSizePic: 30,
            picList: [],
            picLoading: false,


            //文章内容
            word: {
                title: '',
                content: ''
            },
            //编辑器相关
            phoneEditor: null,
            editorOption: {
                modules: {
                    toolbar: {
                        container: [
                            ["bold", "italic", "underline", "strike"], //不需要设置值，直接写名字
                            [{ header: 1 }, { header: 2 }], //需要设置值
                            [{ script: "sub" }, { script: "super" }],
                            [{ size: ["small", false, "large", "huge"] }],
                            [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
                            ["image"] //上传图片
                        ]
                    }
                }
            },


            // 创建或归档
            uploadMode: 0,

            //资源夹信息
            atlasForm: {
                libId: "",
                name: "",
                desc: "",
                status: "",
                sourceType: "0",
                indexpicId: "0",
                createUid: this.createUid,
            },
            minRows: 6,
            maxRows: 10,
            isSave: false,
            statusFlag: false,
            isrouteBtn: false,
            rules: {
                name: [
                    { required: true, message: "请选择归属资源库", trigger: "blur" },
                    {  min: 0, max: 60, message: "长度在 60 个字符以内", trigger: "blur" },
                ],
                desc: [
                    {
                        min: 0,
                        max: 200,
                        message: "长度在 200 个字符以内",
                        trigger: "blur",
                    },
                ],
                libId: [
                    { required: true, message: "请选择归属资源库", trigger: "change" },
                ],
                status: [
                    { required: true, message: "请选择可见性", trigger: "change" },
                ],
            },

            //归属到个人资源库
            myLibId: 0,
            myAtlasId: 0,
            myselect: "",
            myAtlas: [],
            tableLoading:false,
            atlasInfo: null
        }
    },
    methods: {
        //图片右击
        rightShow(e) {
            this.rightMouseLeft = e.clientX;
            this.rightMouseTop = e.clientY;
            setTimeout(() => {
                this.rightMouseFlag = true;
            }, 200);
            setTimeout(() => {
                this.rightMouseFlag = false;
            }, 2000);
            // this.$message('版权所有')
        },

        //切换上传方式（创建新图集或归档到图集）
        changeUploadMode() {
            if (this.uploadMode === 0) {
                this.uploadMode = 1;
            } else {
                this.uploadMode = 0;
            }
            this.myselect = ''
            this.myLibId = '';
            this.myAtlasId = '';
            this.tableLoading = true
            this.searchAtlasAsync({ pageSize: 20, page: 0, createUid: this.createUid });
        },
        //保存并上传事件
        save(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if(!this.word.title){
                        this.$message.warning('请填写文章标题！')
                        return false;
                    }
                    if(!this.phoneEditor.txt.html()){
                        this.$message.warning('请填写文章内容！')
                        return false;
                    }
                    // console.log(this.word);
                    this.saveLoading = true
                    this.addWordLoading = true
                    this.addAtlasAsync(this.atlasForm);
                }
            })

        },
        //保存并上传事件
        saveG(formName) {
            if (this.myLibId == 0) {
                this.$message.warning("请选择资源夹");
                return false;
            }
            if(!this.word.title){
                this.$message.warning('请填写文章标题！')
                return false;
            }
            if(!this.phoneEditor.txt.html()){
                this.$message.warning('请填写文章内容！')
                return false;
            }
            
            this.saveLoading = true
            this.addWordLoading = true
            this.createAsync({
                    atlasId:this.myAtlasId,
                    createUid:this.createUid,
                    path:this.phoneEditor.txt.html(),
                    libId:this.myLibId,
                    title:this.word.title
            })
        },






        //获取用户列表
        async listUserAsync() {
            let { status, data, message, pagination } = await listUser({ pageSize: 100, userType: 0 });
            if (status) {
                this.contributorList = [
                    {
                        id: -1,
                        name: "不限",
                    },
                ];
                for (let i = 0; i < data.length; i++) {
                    if (data[i].status === 1) {
                        if (data[i].userType === 0) {
                            this.contributorList.push({
                                id: data[i].id,
                                name: data[i].name,
                            });
                        }
                    }
                }
            }
        },
        //获取图片库列表
        async listLibAsync() {
            let { status, data, message } = await listLib({ pageSize: 1000 });
            // if (status) {
                this.atlaslist = [
                    {
                        id: 0,
                        name: "不限"
                    }
                ]
                this.options = []
                if (localStorage.getItem('createUid') == 60000) {
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].status === 1) {
                            this.atlaslist.push({
                                id: data[i].id,
                                name: data[i].name,
                                children:[]
                            });
                        }
                    }

                    for (let i = 0;i < this.atlaslist.length;i++) {
                        let flag = 0
                        for (let j = 0; j < this.allowLib.length; j++) {
                            if(this.allowLib[j].toString().indexOf('-') !== -1){
                            if(this.atlaslist[i].id == this.allowLib[j].split('-')[0]){
                                flag++
                                this.atlaslist[i].children.push({
                                id: this.allowLib[j].split('-')[1],
                                name: ''
                                })
                            }
                            }
                            
                        }
                        if(flag == 0){
                            delete this.atlaslist[i].children
                        }
                    }

                    for (let i = 0; i < this.atlaslist.length; i++) {
                        if(this.atlaslist[i].hasOwnProperty('children')){
                        if(this.atlaslist[i].children.length > 0){
                            let spliceNum = []
                            for (let z = 0; z < this.atlaslist[i].children.length; z++) {
                                for (let j = 0; j < data.length; j++) {
                                    if(data[j].id == this.atlaslist[i].children[z].id){
                                        if(data[j].status === 1){
                                            this.atlaslist[i].children[z].name = data[j].name
                                        }else{
                                            spliceNum.push(z)
                                        }
                                    }
                                    
                                }
                            
                            }

                            for (let index = 0; index < spliceNum.length; index++) {
                                this.atlaslist[i].children.splice(spliceNum[index] - index,1)
                            }
                            
                            if(this.atlaslist[i].children.length == 0){
                                delete this.atlaslist[i]
                            }
                            
                        }
                        }
                        
                        
                    }

                    this.options = JSON.parse(JSON.stringify(this.atlaslist))
                    this.options.shift()
                } else {
                    this.listMyPowerLibAsync()
                }

                

                
            // }
        },
        async listMyPowerLibAsync() {
            let { status, data, message, pagination } = await listMyPowerLib({ pageSize: 1000 });
            // if (status) {
                this.atlaslist = [{
                    id: 0,
                    name: "不限"
                }]
                for (let i = 0; i < data.length; i++) {
                    if (this.allowLib.indexOf(data[i].id.toString()) !== -1) {
                        if (data[i].status === 1) {
                            this.atlaslist.push({
                                id: data[i].id,
                                name: data[i].name,
                                children:[]
                            });
                        }
                    }
                }

                for (let i = 0;i < this.atlaslist.length;i++) {
                    let flag = 0
                    for (let j = 0; j < this.allowLib.length; j++) {
                        if(this.allowLib[j].toString().indexOf('-') !== -1){
                        if(this.atlaslist[i].id == this.allowLib[j].split('-')[0]){
                            flag++
                            this.atlaslist[i].children.push({
                            id: this.allowLib[j].split('-')[1],
                            name: ''
                            })
                        }
                        }
                        
                    }
                    if(flag == 0){
                        delete this.atlaslist[i].children
                    }
                }

                for (let i = 0; i < this.atlaslist.length; i++) {
                    if(this.atlaslist[i].hasOwnProperty('children')){
                    if(this.atlaslist[i].children.length > 0){
                        let spliceNum = []
                            for (let z = 0; z < this.atlaslist[i].children.length; z++) {
                                for (let j = 0; j < data.length; j++) {
                                    if(data[j].id == this.atlaslist[i].children[z].id){
                                        if(data[j].status === 1){
                                            this.atlaslist[i].children[z].name = data[j].name
                                        }else{
                                            spliceNum.push(z)
                                        }
                                    }
                                    
                                }
                            
                            }

                            console.log(spliceNum,111);

                            for (let index = 0; index < spliceNum.length; index++) {
                                this.atlaslist[i].children.splice(spliceNum[index] - index,1)
                            }
                            
                            if(this.atlaslist[i].children.length == 0){
                                delete this.atlaslist[i]
                            }

                            for (let z = 0; z < this.atlaslist[i].children.length; z++) {
                                if(!this.atlaslist[i].children[z].name){
                                    this.atlaslist[i].children.splice(z,1)
                                }
                            }
                    }
                    }
                    
                    
                }

                this.options = JSON.parse(JSON.stringify(this.atlaslist))
                this.options.shift()
                
            // }
        },
        //选中图片到编辑器
        choosePic(e) {
            console.log(e);
            this.phoneEditor.txt.append(`<img src="${e.savepath}"  style="max-width:100%;" alt />`)
        },
        //图片滚动加载
        picScroll(e) {
            // console.log(e.srcElement.scrollTop, this.$refs.picdetail.offsetHeight);

            if (e.srcElement.scrollTop + 607 >= this.$refs.picdetail.offsetHeight) {
                if (this.totalPic !== this.picList.length) {
                    this.pagePic++
                    let val = {
                        page: this.pagePic,
                        pageSize: this.pageSizePic,
                        createUid: this.pic.user,
                        libId: this.pic.id
                    }
                    setTimeout(() => {
                        this.advSearchPictureAsync(val)
                    }, 200);
                }
            }
        },
        //图片筛选
        inputchange() {
            this.pagePic = 0
            let val = {
                page: this.pagePic,
                pageSize: this.pageSizePic,
                createUid: this.pic.user,
                libId: this.pic.id
            }
            this.advSearchPictureAsync(val)
        },
        //检索图片
        async advSearchPictureAsync(val) {
            let { status, data, message, pagination, errors } = await advSearchPicture(
                val
            );
            if (status) {
                this.picLoading = false
                if (this.pagePic == 0) {
                    this.picList = data;
                } else {
                    for (let i = 0; i < data.length; i++) {
                        this.picList.push(data[i]);
                    }
                }
                this.totalPic = pagination.total;

                for (let i = 0; i < this.picList.length; i++) {
                    this.picList[i].savepath =
                        picPrefix + this.picList[i].savepath;
                    if (this.picList[i].picThumbW240H160) {
                        this.picList[i].src =
                            picPrefix + this.picList[i].picThumbW240H160;
                        this.picList[i].srcW1080 =
                            picPrefix + this.picList[i].picThumbW1080;
                    } else {
                        this.picList[i].src = require("@/assets/house/onloadpicin.png");
                        this.picList[
                            i
                        ].srcW1080 = picPrefix + this.picList[i].savepath;
                    }


                    //图片加载失败
                    if (this.picList[i].picThumbW240H160 === "error") {
                        this.picList[i].errortext = "error";
                        this.picList[
                            i
                        ].src = require("@/assets/house/onloadpicerror.png");
                        this.picList[
                            i
                        ].picThumbWh160 = require("@/assets/house/onloadpicerror.png");
                        this.picList[
                            i
                        ].srcW1080 = picPrefix + this.picList[i].savepath;
                    }
                    let imgTest = new Image();
                    imgTest.src = this.picList[i].src;
                    imgTest.onerror = () => {
                        this.picList[i].errortext = "error";
                        this.picList[
                            i
                        ].src = require("@/assets/house/onloadpicerror.png");
                        this.picList[
                            i
                        ].picThumbWh160 = require("@/assets/house/onloadpicerror.png");
                        this.picList[
                            i
                        ].srcW1080 = picPrefix + this.picList[i].savepath;
                    };

                }
            } else {
                this.picLoading = false
                let errortext = "";
                for (const key in errors) {
                    errortext += errors[key];
                }
                this.$message.error({ message: message + errortext });
            }
        },

        //归档到图集
        rowClick(row) {
            this.atlasInfo = row
            this.myLibId = row.libId;
            this.myAtlasId = row.atlasId;
        },
        myLibChange() {
            // console.log(this.myselect)
            if (!this.myselect) {
                this.myAtlas = [];
                this.tableLoading = true
                this.searchAtlasAsync({
                    pageSize: 20,
                    page: 0,
                    createUid: this.createUid,
                });
            }
            if (this.myselect.length >= 2) {
                this.myAtlas = [];
                this.tableLoading = true
                this.searchAtlasAsync({
                    keyword: this.myselect,
                    pageSize: 50,
                    page: 0,
                    createUid: this.createUid,
                });
            }
        },
        //获取图集
        async searchAtlasAsync(val) {
            let { status, data, message } = await searchAtlas(val);
            if (status) {
                this.tableLoading = false
                this.myAtlas = [];
                for (let i = 0; i < data.length; i++) {
                    this.myAtlas.push({
                        name:
                            "[" +
                            (data[i].libInfo ? data[i].libInfo.name : "暂无") +
                            "] " +
                            data[i].name,
                        date: formatConversion(data[i].createAt.toString()),
                        libId: data[i].libId,
                        atlasId: data[i].id,
                        atlasName: data[i].name,
                        atlasDesc: data[i].desc,
                    });
                }
                // this.myAtlasId = this.myAtlas[0].label;
            } else {
                this.tableLoading = false
                // this.$message.error(message);
            }
        },


        //编辑器上传图片事件
        //通过md5查询图片
        async getFileInfoByHashAsync(val, blob, b, t, insert) {
            let { status, data, message } = await getFileInfoByHash(val);
            if (!status) {
                this.fragmentation(val, blob, b, t, insert);
            } else {
                if (insert !== 1) {
                    let src = picPrefix + data.savepath;
                    insert(src);
                    this.phoneEditor.txt.html(this.phoneEditor.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
                }

            }
        },
        //分片上传
        fragmentation(val, blob, bytesPerPiece, totalPieces, insert) {
            var start = 0;
            var end;
            var index = 0;
            var filesize = blob.size;
            var filename = blob.name;

            totalPieces = Math.ceil(filesize / bytesPerPiece);

            while (start < filesize) {
                end = start + bytesPerPiece;
                if (end > filesize) {
                    end = filesize;
                }

                var chunk = blob.slice(start, end); //切割文件
                var sliceIndex = blob.name + index;
                var formData = new FormData();
                formData.append("file", chunk);

                let params = {
                    chunk: index,
                    hash: val
                };

                if (index < totalPieces) {
                    // console.log('分片次数',index)
                    this.uploadPicChunkAsync(params, formData, blob, insert);
                }
                if (index === totalPieces - 1) {
                    // console.log('分片合并')
                    params = {
                        chunkCount: totalPieces,
                        filename: blob.name,
                        hash: val
                    };
                    this.uploadPicChunkMergeAsync(params, blob, insert);
                }
                start = end;
                index++;
            }
        },
        //常规文件上传
        async uploadPicAsync(val, insert) {
            let { status, data, message } = await uploadPic(val);
            if (status) {
                if (insert !== 1) {
                    let src = picPrefix + data.savepath;
                    insert(src);
                    this.phoneEditor.txt.html(this.phoneEditor.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
                }
            }
        },
        //分片上传接口第一步
        async uploadPicChunkAsync(params, val, blob, insert) {
            let { status, data, message } = await uploadPicChunk(params, val);
            if (!status) {
                let fd = new FormData();
                fd.append("file", blob);
                this.uploadPicAsync(fd, insert);
            } else {
                console.log("分片第一步");
            }
        },
        //分片上传接口第二步
        async uploadPicChunkMergeAsync(params, blob, insert) {
            let { status, data, message } = await uploadPicChunkMerge(params);
            if (!status) {
                let fd = new FormData();
                fd.append("file", blob);
                this.uploadPicAsync(fd, insert);
            } else {
                if (insert !== 1) {
                    let src = picPrefix + data.savepath;
                    insert(src);
                    this.phoneEditor.txt.html(this.phoneEditor.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
                    // console.log(this.phoneEditor.txt.html().substring(this.phoneEditor.txt.html().indexOf('el-icon-loading') - 10,this.phoneEditor.txt.html().indexOf('el-icon-loading') + 21))
                }
            }
        },
        //创建图集
        async addAtlasAsync(val) {
            let libArr = val.libId
            if(libArr.length >= 2){
                val.parentLibId = parseInt(libArr[0])
                val.libId = parseInt(libArr[1])
            }else{
                val.parentLibId = 0
                val.libId = parseInt(libArr[0])
            }
            let { status, data, message, errors } = await addAtlas(val);
            if (status) {
                console.log(data);
                this.createAsync({
                    atlasId:data.id,
                    createUid:this.createUid,
                    path:this.phoneEditor.txt.html(),
                    libId:data.libId,
                    title:this.word.title
                })
                this.$refs["ruleForm"].resetFields();
                
            }else{
                this.addWordLoading = false
                this.$message.warning('创建图集失败!')
            }
        },
        //创建文稿对象
        async createAsync(val) {
            let { status, data, message } = await create(val);
            if (status) {
                this.saveLoading = false
                this.addWordLoading = false
                this.$message.success('创建成功!')

                this.$router.push({
                    path: '/pictureCenter'
                })
            }else{
                this.addWordLoading = false
                this.saveLoading = false
                this.$message.warning('创建图集失败!')
            }
                
        },

        //检索单个文稿
        async selectInfoAsync() {
            let { status, data, message, errors } = await selectInfo(
                {
                    id:this.$route.query.id
                }
            );
            if(status){
                this.word.content = data.content
                this.word.title = data.document.title
                this.updateWordInfo = data
                this.phoneEditor.txt.html(this.word.content);
            }
        },

        //修改单个文稿
        async updateContentAsync(val) {
            let { status, data, message, errors } = await updateContent(
                val
            );
            if(status){
                console.log(data);
                this.saveLoading = false
                this.$message.success('修改成功!')
                setTimeout(() => {
                    this.$router.go(-1)
                }, 1000);
            }else{
                this.saveLoading = false
                this.$message.warning('修改失败!')
            }
        },

        updateWord(){
            this.saveLoading = true
            this.updateContentAsync({
                        atlasId:this.updateWordInfo.document.atlasId,
                        id:this.updateWordInfo.document.id,
                        libId:this.updateWordInfo.document.libId,
                        title:this.word.title,
                        path:this.phoneEditor.txt.html(),
                        createUid:this.createUid,
            })
        },
    },

    created() {
        if(this.$route.query.id){
            console.log(this.$route.query.id);
            this.selectInfoAsync()
        }
        this.listUserAsync()
        this.listLibAsync()
        this.picLoading = true
        this.advSearchPictureAsync({
            page: this.pagePic,
            pageSize: this.pageSizePic,
            status: 1,
        })

        //判断类型
        let createLength = 0;

        if (powersObj.createPrivateAtlas) {
            this.statusFlag = true;
            this.atlasForm.status = "0";
        } else {
            createLength++;
        }
        if (powersObj.createPublicAtlas) {
            this.statusFlag = true;
            this.atlasForm.status = "1";
        } else {
            createLength++;
        }

        if (createLength == 2) {
            this.isSave = true;
            this.statusFlag = true;
            this.isrouteBtn = true;
            this.isIncludeChineseFlag = false;
            this.$message.warning("请联系管理员添加可见性的权限！");
        }

        if (createLength == 0) {
            this.statusFlag = false;
            this.atlasForm.status = "0";
        }
    },


    mounted() {
        var that = this;
        this.phoneEditor = new E("#websiteEditorElem");
        // 隐藏网络图片
        this.phoneEditor.customConfig.showLinkImg = false;


        // 自定义菜单配置
        this.phoneEditor.customConfig.menus = [
            "head", // 标题
            "bold", // 粗体
            "fontSize", // 字号
            "fontName", // 字体
            "italic", // 斜体
            "underline", // 下划线
            "foreColor", // 文字颜色
            "backColor", // 背景颜色
            // 'link',  // 插入链接
            // 'list',  // 列表
            "justify", // 对齐方式
            "quote", // 引用
            "image", // 插入图片
            // 'table',  // 表格
            // 'video',  // 插入视频
            // 'code',  // 插入代码
            "undo", // 撤销
            "redo" // 重复
        ];

        // 将图片大小限制为 50M
        this.phoneEditor.customConfig.uploadImgMaxSize = 50 * 1024 * 1024;

        // 限制一次最多上传 10 张图片
        this.phoneEditor.customConfig.uploadImgMaxLength = 10;

        //上传图片事件
        this.phoneEditor.customConfig.customUploadImg = function (files, insert) {
            let bytesPerPiece;
            let totalPieces;
            let fileMD5;
            let icon = '<i style="font-size:24px" class="el-icon-loading"></i>'
            that.phoneEditor.txt.html(that.phoneEditor.txt.html() + icon)

            files.forEach(item => {
                if (item.size > 560000) {
                    bytesPerPiece = 202020;
                } else {
                    bytesPerPiece = 9888;
                }
                getMD5(item, md5 => {
                    that.getFileInfoByHashAsync(
                        md5,
                        item,
                        bytesPerPiece,
                        totalPieces,
                        insert
                    );
                });

            });
        };


        // 创建一个富文本编辑器
        this.phoneEditor.create();
        // 富文本内容
        this.phoneEditor.txt.html(this.word.content);
    }
}
</script>

<style lang="scss" scoped>
@import "./addword.scss";

::v-deep .el-loading-mask{
    z-index: 990999 !important;
}
</style>